var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Schema } from "../Schema/";

import PreviewHeader from "./PreviewHeader";
import PreviewField from "./PreviewField";

import "./PreviewSchema.scss";

var layouts = {
    "document": PreviewField,
    "section": PreviewField,
    "block": PreviewField,
    "fieldset": PreviewField,
    "field": PreviewField,
    "module": PreviewField,
    "media": PreviewField
};

var SchemaPreview = (_temp = _class = function (_Component) {
    _inherits(SchemaPreview, _Component);

    function SchemaPreview() {
        _classCallCheck(this, SchemaPreview);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SchemaPreview.prototype.render = function render() {
        var _props = this.props,
            language = _props.language,
            data = _props.data,
            schema = _props.schema,
            formData = _props.formData;


        var fieldType = void 0;

        if (data && data.documentType) {
            fieldType = "document";
        } else if (data && data.mediaType) {
            fieldType = "media";
        }

        return React.createElement(
            "div",
            { className: "admin-preview  preview--schema", "data-type": fieldType },
            React.createElement(PreviewHeader, _extends({}, data, { language: language })),
            React.createElement(Schema, { language: language, schema: schema, formData: formData, layouts: layouts })
        );
    };

    return SchemaPreview;
}(Component), _class.defaultProps = {
    data: {},
    schema: {},
    formData: {}
}, _temp);


export default SchemaPreview;